import { TOGGLE_SIDEBAR } from "./actions";

export function LayoutSettingsReducer(state = {}, action) {
  switch (action.type) {
    case TOGGLE_SIDEBAR: {
      let newState = _.clone(state);
      console.log(action);

      newState.sidebarOpen = !newState.sidebarOpen;
      return newState;
    }
    default:
      return state;
  }
}
